import { toast } from "react-toastify"
import axiosInstance from "../../../services/axios-client"
import { useState } from "react"

const useReject = () => {
    const [payload, setPayload] = useState({
        Comment: ''
    })
    const handleReject = async(setLoadingPage, handleClose) => {
        try {
            handleClose()
            if (payload.Comment!="") {
                setLoadingPage(true)
                let res = await axiosInstance.post(`/auth/calibrations/reject-approval`, payload)
                if (res.status == 200) {
                    setLoadingPage(false)
                    toast.success("Successfully reject calibration")
                    setTimeout(() => {
                        window.location.reload()
                    }, 1000)
                }
            }else{
                toast.error("You should input comment for rejected calibration")
            }
        } catch (error) {
            if(error.response){
                toast.error(error?.response?.data?.status?.description)
            } else if(error.message) {
                toast.error(error.message)
            } else{
                toast.error(error)
            }
        }
    }

    return{
        payload, 
        setPayload,
        handleReject,
    }
}

export default useReject